export const currencyList: Record<
  string,
  {
    name: string;
    symbol_native: string;
    symbol: string;
    code: string;
    name_plural: string;
    rounding: number;
    decimal_digits: number;
  }
> = {
  AFN: {
    name: "Afghan Afghani",
    symbol_native: "؋",
    symbol: "Af",
    code: "AFN",
    name_plural: "Afghan Afghanis",
    rounding: 0,
    decimal_digits: 0,
  },
  ALL: {
    name: "Albanian Lek",
    symbol_native: "Lek",
    symbol: "ALL",
    code: "ALL",
    name_plural: "Albanian lekë",
    rounding: 0,
    decimal_digits: 0,
  },
  DZD: {
    name: "Algerian Dinar",
    symbol_native: "د.ج.‏",
    symbol: "DA",
    code: "DZD",
    name_plural: "Algerian dinars",
    rounding: 0,
    decimal_digits: 2,
  },
  ARS: {
    name: "Argentine Peso",
    symbol_native: "$",
    symbol: "AR$",
    code: "ARS",
    name_plural: "Argentine pesos",
    rounding: 0,
    decimal_digits: 2,
  },
  AMD: {
    name: "Armenian Dram",
    symbol_native: "դր.",
    symbol: "AMD",
    code: "AMD",
    name_plural: "Armenian drams",
    rounding: 0,
    decimal_digits: 0,
  },
  AUD: {
    name: "Australian Dollar",
    symbol_native: "$",
    symbol: "AU$",
    code: "AUD",
    name_plural: "Australian dollars",
    rounding: 0,
    decimal_digits: 2,
  },
  AZN: {
    name: "Azerbaijani Manat",
    symbol_native: "ман.",
    symbol: "man.",
    code: "AZN",
    name_plural: "Azerbaijani manats",
    rounding: 0,
    decimal_digits: 2,
  },
  BHD: {
    name: "Bahraini Dinar",
    symbol_native: "د.ب.‏",
    symbol: "BD",
    code: "BHD",
    name_plural: "Bahraini dinars",
    rounding: 0,
    decimal_digits: 3,
  },
  BDT: {
    name: "Bangladeshi Taka",
    symbol_native: "৳",
    symbol: "Tk",
    code: "BDT",
    name_plural: "Bangladeshi takas",
    rounding: 0,
    decimal_digits: 2,
  },
  BYN: {
    name: "Belarusian Ruble",
    symbol_native: "руб.",
    symbol: "Br",
    code: "BYN",
    name_plural: "Belarusian rubles",
    rounding: 0,
    decimal_digits: 2,
  },
  BZD: {
    name: "Belize Dollar",
    symbol_native: "$",
    symbol: "BZ$",
    code: "BZD",
    name_plural: "Belize dollars",
    rounding: 0,
    decimal_digits: 2,
  },
  BOB: {
    name: "Bolivian Boliviano",
    symbol_native: "Bs",
    symbol: "Bs",
    code: "BOB",
    name_plural: "Bolivian bolivianos",
    rounding: 0,
    decimal_digits: 2,
  },
  BAM: {
    name: "Bosnia-Herzegovina Convertible Mark",
    symbol_native: "KM",
    symbol: "KM",
    code: "BAM",
    name_plural: "Bosnia-Herzegovina convertible marks",
    rounding: 0,
    decimal_digits: 2,
  },
  BWP: {
    name: "Botswanan Pula",
    symbol_native: "P",
    symbol: "BWP",
    code: "BWP",
    name_plural: "Botswanan pulas",
    rounding: 0,
    decimal_digits: 2,
  },
  BRL: {
    name: "Brazilian Real",
    symbol_native: "R$",
    symbol: "R$",
    code: "BRL",
    name_plural: "Brazilian reals",
    rounding: 0,
    decimal_digits: 2,
  },
  GBP: {
    name: "British Pound",
    symbol_native: "£",
    symbol: "£",
    code: "GBP",
    name_plural: "British pounds sterling",
    rounding: 0,
    decimal_digits: 2,
  },
  BND: {
    name: "Brunei Dollar",
    symbol_native: "$",
    symbol: "BN$",
    code: "BND",
    name_plural: "Brunei dollars",
    rounding: 0,
    decimal_digits: 2,
  },
  BGN: {
    name: "Bulgarian Lev",
    symbol_native: "лв.",
    symbol: "BGN",
    code: "BGN",
    name_plural: "Bulgarian leva",
    rounding: 0,
    decimal_digits: 2,
  },
  BIF: {
    name: "Burundian Franc",
    symbol_native: "FBu",
    symbol: "FBu",
    code: "BIF",
    name_plural: "Burundian francs",
    rounding: 0,
    decimal_digits: 0,
  },
  KHR: {
    name: "Cambodian Riel",
    symbol_native: "៛",
    symbol: "KHR",
    code: "KHR",
    name_plural: "Cambodian riels",
    rounding: 0,
    decimal_digits: 2,
  },
  CAD: {
    name: "Canadian Dollar",
    symbol_native: "$",
    symbol: "CA$",
    code: "CAD",
    name_plural: "Canadian dollars",
    rounding: 0,
    decimal_digits: 2,
  },
  CVE: {
    name: "Cape Verdean Escudo",
    symbol_native: "CV$",
    symbol: "CV$",
    code: "CVE",
    name_plural: "Cape Verdean escudos",
    rounding: 0,
    decimal_digits: 2,
  },
  XAF: {
    name: "Central African CFA Franc",
    symbol_native: "FCFA",
    symbol: "FCFA",
    code: "XAF",
    name_plural: "CFA francs BEAC",
    rounding: 0,
    decimal_digits: 0,
  },
  CLP: {
    name: "Chilean Peso",
    symbol_native: "$",
    symbol: "CL$",
    code: "CLP",
    name_plural: "Chilean pesos",
    rounding: 0,
    decimal_digits: 0,
  },
  CNY: {
    name: "Chinese Yuan",
    symbol_native: "CN¥",
    symbol: "CN¥",
    code: "CNY",
    name_plural: "Chinese yuan",
    rounding: 0,
    decimal_digits: 2,
  },
  COP: {
    name: "Colombian Peso",
    symbol_native: "$",
    symbol: "CO$",
    code: "COP",
    name_plural: "Colombian pesos",
    rounding: 0,
    decimal_digits: 0,
  },
  KMF: {
    name: "Comorian Franc",
    symbol_native: "FC",
    symbol: "CF",
    code: "KMF",
    name_plural: "Comorian francs",
    rounding: 0,
    decimal_digits: 0,
  },
  CDF: {
    name: "Congolese Franc",
    symbol_native: "FrCD",
    symbol: "CDF",
    code: "CDF",
    name_plural: "Congolese francs",
    rounding: 0,
    decimal_digits: 2,
  },
  CRC: {
    name: "Costa Rican Colón",
    symbol_native: "₡",
    symbol: "₡",
    code: "CRC",
    name_plural: "Costa Rican colóns",
    rounding: 0,
    decimal_digits: 0,
  },
  HRK: {
    name: "Croatian Kuna",
    symbol_native: "kn",
    symbol: "kn",
    code: "HRK",
    name_plural: "Croatian kunas",
    rounding: 0,
    decimal_digits: 2,
  },
  CZK: {
    name: "Czech Koruna",
    symbol_native: "Kč",
    symbol: "Kč",
    code: "CZK",
    name_plural: "Czech Republic korunas",
    rounding: 0,
    decimal_digits: 2,
  },
  DKK: {
    name: "Danish Krone",
    symbol_native: "kr",
    symbol: "Dkr",
    code: "DKK",
    name_plural: "Danish kroner",
    rounding: 0,
    decimal_digits: 2,
  },
  DJF: {
    name: "Djiboutian Franc",
    symbol_native: "Fdj",
    symbol: "Fdj",
    code: "DJF",
    name_plural: "Djiboutian francs",
    rounding: 0,
    decimal_digits: 0,
  },
  DOP: {
    name: "Dominican Peso",
    symbol_native: "RD$",
    symbol: "RD$",
    code: "DOP",
    name_plural: "Dominican pesos",
    rounding: 0,
    decimal_digits: 2,
  },
  EGP: {
    name: "Egyptian Pound",
    symbol_native: "ج.م.‏",
    symbol: "EGP",
    code: "EGP",
    name_plural: "Egyptian pounds",
    rounding: 0,
    decimal_digits: 2,
  },
  ERN: {
    name: "Eritrean Nakfa",
    symbol_native: "Nfk",
    symbol: "Nfk",
    code: "ERN",
    name_plural: "Eritrean nakfas",
    rounding: 0,
    decimal_digits: 2,
  },
  EEK: {
    name: "Estonian Kroon",
    symbol_native: "kr",
    symbol: "Ekr",
    code: "EEK",
    name_plural: "Estonian kroons",
    rounding: 0,
    decimal_digits: 2,
  },
  ETB: {
    name: "Ethiopian Birr",
    symbol_native: "Br",
    symbol: "Br",
    code: "ETB",
    name_plural: "Ethiopian birrs",
    rounding: 0,
    decimal_digits: 2,
  },
  EUR: {
    name: "Euro",
    symbol_native: "€",
    symbol: "€",
    code: "EUR",
    name_plural: "euros",
    rounding: 0,
    decimal_digits: 2,
  },
  GEL: {
    name: "Georgian Lari",
    symbol_native: "GEL",
    symbol: "GEL",
    code: "GEL",
    name_plural: "Georgian laris",
    rounding: 0,
    decimal_digits: 2,
  },
  GHS: {
    name: "Ghanaian Cedi",
    symbol_native: "GH₵",
    symbol: "GH₵",
    code: "GHS",
    name_plural: "Ghanaian cedis",
    rounding: 0,
    decimal_digits: 2,
  },
  GTQ: {
    name: "Guatemalan Quetzal",
    symbol_native: "Q",
    symbol: "GTQ",
    code: "GTQ",
    name_plural: "Guatemalan quetzals",
    rounding: 0,
    decimal_digits: 2,
  },
  GNF: {
    name: "Guinean Franc",
    symbol_native: "FG",
    symbol: "FG",
    code: "GNF",
    name_plural: "Guinean francs",
    rounding: 0,
    decimal_digits: 0,
  },
  HNL: {
    name: "Honduran Lempira",
    symbol_native: "L",
    symbol: "HNL",
    code: "HNL",
    name_plural: "Honduran lempiras",
    rounding: 0,
    decimal_digits: 2,
  },
  HKD: {
    name: "Hong Kong Dollar",
    symbol_native: "$",
    symbol: "HK$",
    code: "HKD",
    name_plural: "Hong Kong dollars",
    rounding: 0,
    decimal_digits: 2,
  },
  HUF: {
    name: "Hungarian Forint",
    symbol_native: "Ft",
    symbol: "Ft",
    code: "HUF",
    name_plural: "Hungarian forints",
    rounding: 0,
    decimal_digits: 0,
  },
  ISK: {
    name: "Icelandic Króna",
    symbol_native: "kr",
    symbol: "Ikr",
    code: "ISK",
    name_plural: "Icelandic krónur",
    rounding: 0,
    decimal_digits: 0,
  },
  INR: {
    name: "Indian Rupee",
    symbol_native: "টকা",
    symbol: "Rs",
    code: "INR",
    name_plural: "Indian rupees",
    rounding: 0,
    decimal_digits: 2,
  },
  IDR: {
    name: "Indonesian Rupiah",
    symbol_native: "Rp",
    symbol: "Rp",
    code: "IDR",
    name_plural: "Indonesian rupiahs",
    rounding: 0,
    decimal_digits: 0,
  },
  IRR: {
    name: "Iranian Rial",
    symbol_native: "﷼",
    symbol: "IRR",
    code: "IRR",
    name_plural: "Iranian rials",
    rounding: 0,
    decimal_digits: 0,
  },
  IQD: {
    name: "Iraqi Dinar",
    symbol_native: "د.ع.‏",
    symbol: "IQD",
    code: "IQD",
    name_plural: "Iraqi dinars",
    rounding: 0,
    decimal_digits: 0,
  },
  ILS: {
    name: "Israeli New Shekel",
    symbol_native: "₪",
    symbol: "₪",
    code: "ILS",
    name_plural: "Israeli new sheqels",
    rounding: 0,
    decimal_digits: 2,
  },
  JMD: {
    name: "Jamaican Dollar",
    symbol_native: "$",
    symbol: "J$",
    code: "JMD",
    name_plural: "Jamaican dollars",
    rounding: 0,
    decimal_digits: 2,
  },
  JPY: {
    name: "Japanese Yen",
    symbol_native: "￥",
    symbol: "¥",
    code: "JPY",
    name_plural: "Japanese yen",
    rounding: 0,
    decimal_digits: 0,
  },
  JOD: {
    name: "Jordanian Dinar",
    symbol_native: "د.أ.‏",
    symbol: "JD",
    code: "JOD",
    name_plural: "Jordanian dinars",
    rounding: 0,
    decimal_digits: 3,
  },
  KZT: {
    name: "Kazakhstani Tenge",
    symbol_native: "тңг.",
    symbol: "KZT",
    code: "KZT",
    name_plural: "Kazakhstani tenges",
    rounding: 0,
    decimal_digits: 2,
  },
  KES: {
    name: "Kenyan Shilling",
    symbol_native: "Ksh",
    symbol: "Ksh",
    code: "KES",
    name_plural: "Kenyan shillings",
    rounding: 0,
    decimal_digits: 2,
  },
  KWD: {
    name: "Kuwaiti Dinar",
    symbol_native: "د.ك.‏",
    symbol: "KD",
    code: "KWD",
    name_plural: "Kuwaiti dinars",
    rounding: 0,
    decimal_digits: 3,
  },
  LVL: {
    name: "Latvian Lats",
    symbol_native: "Ls",
    symbol: "Ls",
    code: "LVL",
    name_plural: "Latvian lati",
    rounding: 0,
    decimal_digits: 2,
  },
  LBP: {
    name: "Lebanese Pound",
    symbol_native: "ل.ل.‏",
    symbol: "LB£",
    code: "LBP",
    name_plural: "Lebanese pounds",
    rounding: 0,
    decimal_digits: 0,
  },
  LYD: {
    name: "Libyan Dinar",
    symbol_native: "د.ل.‏",
    symbol: "LD",
    code: "LYD",
    name_plural: "Libyan dinars",
    rounding: 0,
    decimal_digits: 3,
  },
  LTL: {
    name: "Lithuanian Litas",
    symbol_native: "Lt",
    symbol: "Lt",
    code: "LTL",
    name_plural: "Lithuanian litai",
    rounding: 0,
    decimal_digits: 2,
  },
  MOP: {
    name: "Macanese Pataca",
    symbol_native: "MOP$",
    symbol: "MOP$",
    code: "MOP",
    name_plural: "Macanese patacas",
    rounding: 0,
    decimal_digits: 2,
  },
  MKD: {
    name: "Macedonian Denar",
    symbol_native: "MKD",
    symbol: "MKD",
    code: "MKD",
    name_plural: "Macedonian denari",
    rounding: 0,
    decimal_digits: 2,
  },
  MGA: {
    name: "Malagasy Ariary",
    symbol_native: "MGA",
    symbol: "MGA",
    code: "MGA",
    name_plural: "Malagasy Ariaries",
    rounding: 0,
    decimal_digits: 0,
  },
  MYR: {
    name: "Malaysian Ringgit",
    symbol_native: "RM",
    symbol: "RM",
    code: "MYR",
    name_plural: "Malaysian ringgits",
    rounding: 0,
    decimal_digits: 2,
  },
  MUR: {
    name: "Mauritian Rupee",
    symbol_native: "MURs",
    symbol: "MURs",
    code: "MUR",
    name_plural: "Mauritian rupees",
    rounding: 0,
    decimal_digits: 0,
  },
  MXN: {
    name: "Mexican Peso",
    symbol_native: "$",
    symbol: "MX$",
    code: "MXN",
    name_plural: "Mexican pesos",
    rounding: 0,
    decimal_digits: 2,
  },
  MDL: {
    name: "Moldovan Leu",
    symbol_native: "MDL",
    symbol: "MDL",
    code: "MDL",
    name_plural: "Moldovan lei",
    rounding: 0,
    decimal_digits: 2,
  },
  MAD: {
    name: "Moroccan Dirham",
    symbol_native: "د.م.‏",
    symbol: "MAD",
    code: "MAD",
    name_plural: "Moroccan dirhams",
    rounding: 0,
    decimal_digits: 2,
  },
  MZN: {
    name: "Mozambican Metical",
    symbol_native: "MTn",
    symbol: "MTn",
    code: "MZN",
    name_plural: "Mozambican meticals",
    rounding: 0,
    decimal_digits: 2,
  },
  MMK: {
    name: "Myanmar Kyat",
    symbol_native: "K",
    symbol: "MMK",
    code: "MMK",
    name_plural: "Myanma kyats",
    rounding: 0,
    decimal_digits: 0,
  },
  NAD: {
    name: "Namibian Dollar",
    symbol_native: "N$",
    symbol: "N$",
    code: "NAD",
    name_plural: "Namibian dollars",
    rounding: 0,
    decimal_digits: 2,
  },
  NPR: {
    name: "Nepalese Rupee",
    symbol_native: "नेरू",
    symbol: "NPRs",
    code: "NPR",
    name_plural: "Nepalese rupees",
    rounding: 0,
    decimal_digits: 2,
  },
  TWD: {
    name: "New Taiwan Dollar",
    symbol_native: "NT$",
    symbol: "NT$",
    code: "TWD",
    name_plural: "New Taiwan dollars",
    rounding: 0,
    decimal_digits: 2,
  },
  NZD: {
    name: "New Zealand Dollar",
    symbol_native: "$",
    symbol: "NZ$",
    code: "NZD",
    name_plural: "New Zealand dollars",
    rounding: 0,
    decimal_digits: 2,
  },
  NIO: {
    name: "Nicaraguan Córdoba",
    symbol_native: "C$",
    symbol: "C$",
    code: "NIO",
    name_plural: "Nicaraguan córdobas",
    rounding: 0,
    decimal_digits: 2,
  },
  NGN: {
    name: "Nigerian Naira",
    symbol_native: "₦",
    symbol: "₦",
    code: "NGN",
    name_plural: "Nigerian nairas",
    rounding: 0,
    decimal_digits: 2,
  },
  NOK: {
    name: "Norwegian Krone",
    symbol_native: "kr",
    symbol: "Nkr",
    code: "NOK",
    name_plural: "Norwegian kroner",
    rounding: 0,
    decimal_digits: 2,
  },
  OMR: {
    name: "Omani Rial",
    symbol_native: "ر.ع.‏",
    symbol: "OMR",
    code: "OMR",
    name_plural: "Omani rials",
    rounding: 0,
    decimal_digits: 3,
  },
  PKR: {
    name: "Pakistani Rupee",
    symbol_native: "₨",
    symbol: "PKRs",
    code: "PKR",
    name_plural: "Pakistani rupees",
    rounding: 0,
    decimal_digits: 0,
  },
  PAB: {
    name: "Panamanian Balboa",
    symbol_native: "B/.",
    symbol: "B/.",
    code: "PAB",
    name_plural: "Panamanian balboas",
    rounding: 0,
    decimal_digits: 2,
  },
  PYG: {
    name: "Paraguayan Guarani",
    symbol_native: "₲",
    symbol: "₲",
    code: "PYG",
    name_plural: "Paraguayan guaranis",
    rounding: 0,
    decimal_digits: 0,
  },
  PEN: {
    name: "Peruvian Sol",
    symbol_native: "S/.",
    symbol: "S/.",
    code: "PEN",
    name_plural: "Peruvian nuevos soles",
    rounding: 0,
    decimal_digits: 2,
  },
  PHP: {
    name: "Philippine Peso",
    symbol_native: "₱",
    symbol: "₱",
    code: "PHP",
    name_plural: "Philippine pesos",
    rounding: 0,
    decimal_digits: 2,
  },
  PLN: {
    name: "Polish Zloty",
    symbol_native: "zł",
    symbol: "zł",
    code: "PLN",
    name_plural: "Polish zlotys",
    rounding: 0,
    decimal_digits: 2,
  },
  QAR: {
    name: "Qatari Rial",
    symbol_native: "ر.ق.‏",
    symbol: "QR",
    code: "QAR",
    name_plural: "Qatari rials",
    rounding: 0,
    decimal_digits: 2,
  },
  RON: {
    name: "Romanian Leu",
    symbol_native: "RON",
    symbol: "RON",
    code: "RON",
    name_plural: "Romanian lei",
    rounding: 0,
    decimal_digits: 2,
  },
  RUB: {
    name: "Russian Ruble",
    symbol_native: "₽.",
    symbol: "RUB",
    code: "RUB",
    name_plural: "Russian rubles",
    rounding: 0,
    decimal_digits: 2,
  },
  RWF: {
    name: "Rwandan Franc",
    symbol_native: "FR",
    symbol: "RWF",
    code: "RWF",
    name_plural: "Rwandan francs",
    rounding: 0,
    decimal_digits: 0,
  },
  SAR: {
    name: "Saudi Riyal",
    symbol_native: "ر.س.‏",
    symbol: "SR",
    code: "SAR",
    name_plural: "Saudi riyals",
    rounding: 0,
    decimal_digits: 2,
  },
  RSD: {
    name: "Serbian Dinar",
    symbol_native: "дин.",
    symbol: "din.",
    code: "RSD",
    name_plural: "Serbian dinars",
    rounding: 0,
    decimal_digits: 0,
  },
  SGD: {
    name: "Singapore Dollar",
    symbol_native: "$",
    symbol: "S$",
    code: "SGD",
    name_plural: "Singapore dollars",
    rounding: 0,
    decimal_digits: 2,
  },
  SOS: {
    name: "Somali Shilling",
    symbol_native: "Ssh",
    symbol: "Ssh",
    code: "SOS",
    name_plural: "Somali shillings",
    rounding: 0,
    decimal_digits: 0,
  },
  ZAR: {
    name: "South African Rand",
    symbol_native: "R",
    symbol: "R",
    code: "ZAR",
    name_plural: "South African rand",
    rounding: 0,
    decimal_digits: 2,
  },
  KRW: {
    name: "South Korean Won",
    symbol_native: "₩",
    symbol: "₩",
    code: "KRW",
    name_plural: "South Korean won",
    rounding: 0,
    decimal_digits: 0,
  },
  LKR: {
    name: "Sri Lankan Rupee",
    symbol_native: "SL Re",
    symbol: "SLRs",
    code: "LKR",
    name_plural: "Sri Lankan rupees",
    rounding: 0,
    decimal_digits: 2,
  },
  SDG: {
    name: "Sudanese Pound",
    symbol_native: "SDG",
    symbol: "SDG",
    code: "SDG",
    name_plural: "Sudanese pounds",
    rounding: 0,
    decimal_digits: 2,
  },
  SEK: {
    name: "Swedish Krona",
    symbol_native: "kr",
    symbol: "Skr",
    code: "SEK",
    name_plural: "Swedish kronor",
    rounding: 0,
    decimal_digits: 2,
  },
  CHF: {
    name: "Swiss Franc",
    symbol_native: "CHF",
    symbol: "CHF",
    code: "CHF",
    name_plural: "Swiss francs",
    rounding: 0.05,
    decimal_digits: 2,
  },
  SYP: {
    name: "Syrian Pound",
    symbol_native: "ل.س.‏",
    symbol: "SY£",
    code: "SYP",
    name_plural: "Syrian pounds",
    rounding: 0,
    decimal_digits: 0,
  },
  TZS: {
    name: "Tanzanian Shilling",
    symbol_native: "TSh",
    symbol: "TSh",
    code: "TZS",
    name_plural: "Tanzanian shillings",
    rounding: 0,
    decimal_digits: 0,
  },
  THB: {
    name: "Thai Baht",
    symbol_native: "฿",
    symbol: "฿",
    code: "THB",
    name_plural: "Thai baht",
    rounding: 0,
    decimal_digits: 2,
  },
  TOP: {
    name: "Tongan Paʻanga",
    symbol_native: "T$",
    symbol: "T$",
    code: "TOP",
    name_plural: "Tongan paʻanga",
    rounding: 0,
    decimal_digits: 2,
  },
  TTD: {
    name: "Trinidad & Tobago Dollar",
    symbol_native: "$",
    symbol: "TT$",
    code: "TTD",
    name_plural: "Trinidad and Tobago dollars",
    rounding: 0,
    decimal_digits: 2,
  },
  TND: {
    name: "Tunisian Dinar",
    symbol_native: "د.ت.‏",
    symbol: "DT",
    code: "TND",
    name_plural: "Tunisian dinars",
    rounding: 0,
    decimal_digits: 3,
  },
  TRY: {
    name: "Turkish Lira",
    symbol_native: "₺",
    symbol: "TL",
    code: "TRY",
    name_plural: "Turkish Lira",
    rounding: 0,
    decimal_digits: 2,
  },
  USD: {
    name: "US Dollar",
    symbol_native: "$",
    symbol: "$",
    code: "USD",
    name_plural: "US dollars",
    rounding: 0,
    decimal_digits: 2,
  },
  UGX: {
    name: "Ugandan Shilling",
    symbol_native: "USh",
    symbol: "USh",
    code: "UGX",
    name_plural: "Ugandan shillings",
    rounding: 0,
    decimal_digits: 0,
  },
  UAH: {
    name: "Ukrainian Hryvnia",
    symbol_native: "₴",
    symbol: "₴",
    code: "UAH",
    name_plural: "Ukrainian hryvnias",
    rounding: 0,
    decimal_digits: 2,
  },
  AED: {
    name: "United Arab Emirates Dirham",
    symbol_native: "د.إ.‏",
    symbol: "AED",
    code: "AED",
    name_plural: "UAE dirhams",
    rounding: 0,
    decimal_digits: 2,
  },
  UYU: {
    name: "Uruguayan Peso",
    symbol_native: "$",
    symbol: "$U",
    code: "UYU",
    name_plural: "Uruguayan pesos",
    rounding: 0,
    decimal_digits: 2,
  },
  UZS: {
    name: "Uzbekistani Som",
    symbol_native: "UZS",
    symbol: "UZS",
    code: "UZS",
    name_plural: "Uzbekistan som",
    rounding: 0,
    decimal_digits: 0,
  },
  VEF: {
    name: "Venezuelan Bolívar",
    symbol_native: "Bs.F.",
    symbol: "Bs.F.",
    code: "VEF",
    name_plural: "Venezuelan bolívars",
    rounding: 0,
    decimal_digits: 2,
  },
  VND: {
    name: "Vietnamese Dong",
    symbol_native: "₫",
    symbol: "₫",
    code: "VND",
    name_plural: "Vietnamese dong",
    rounding: 0,
    decimal_digits: 0,
  },
  XOF: {
    name: "West African CFA Franc",
    symbol_native: "CFA",
    symbol: "CFA",
    code: "XOF",
    name_plural: "CFA francs BCEAO",
    rounding: 0,
    decimal_digits: 0,
  },
  YER: {
    name: "Yemeni Rial",
    symbol_native: "ر.ي.‏",
    symbol: "YR",
    code: "YER",
    name_plural: "Yemeni rials",
    rounding: 0,
    decimal_digits: 0,
  },
  ZMK: {
    name: "Zambian Kwacha",
    symbol_native: "ZK",
    symbol: "ZK",
    code: "ZMK",
    name_plural: "Zambian kwachas",
    rounding: 0,
    decimal_digits: 0,
  },
  ZWL: {
    name: "Zimbabwean Dollar",
    symbol_native: "ZWL$",
    symbol: "ZWL$",
    code: "ZWL",
    name_plural: "Zimbabwean Dollar",
    rounding: 0,
    decimal_digits: 0,
  },
};
